// extracted by mini-css-extract-plugin
export var hideEditor = "_iq-2";
export var infoIcon = "_iq-3";
export var label = "_iq-1";
export var labelContainer = "_iq-0";
export var readonlyText = "_iq-4";